import LastTwoAssetTransactionsWidget from './LastTwoAssetTransactionsWidget';

export default LastTwoAssetTransactionsWidget;